import type {
  Tracker,
  SDKConfigInput,
  DeployStage,
} from '@schibsted/pulse-sdk';

import { getActorPromise } from '../../../src/core/mandatory-integrations/pulse/utils/index.js';
import { isLocalhost, isReviewApp } from '../../core/js/utils/is-localhost.js';

let byfunnPulseTracker: Promise<Tracker> | undefined;

const getDeployInfo = (): { deployStage: DeployStage; deployTag: string } => {
  const host = window.location.hostname;

  if (isLocalhost()) {
    return { deployStage: 'dev', deployTag: 'fasten-dev' };
  } else if (isReviewApp()) {
    return { deployStage: 'dev', deployTag: 'fasten-pr' };
  } else if (host.startsWith('alpha.')) {
    return { deployStage: 'dev', deployTag: 'fasten-alpha' };
  } else if (host.startsWith('beta.')) {
    return { deployStage: 'dev', deployTag: 'fasten-beta' };
  } else {
    return { deployStage: 'pro', deployTag: 'fasten-prod' };
  }
};

const getByfunnPulseSdkConfigInput = (): SDKConfigInput => ({
  nativeJwe: window.hermesJwe,
  altEventHandler: window.pulseEventHandler,
  autoCreateConsents: true,
  requireAdvertisingOptIn: true,
  adChoicesEnabled: true,
  deployStageTpaas: 'pre',
});

export const getByfunnPulseTracker = (
  providerId: string,
  productTag?: string,
): Promise<Tracker> => {
  if (byfunnPulseTracker) {
    return byfunnPulseTracker;
  }

  byfunnPulseTracker = import('@schibsted/pulse-sdk').then(({ Tracker }) => {
    const { deployStage, deployTag } = getDeployInfo();

    const tracker = new Tracker(
      providerId,
      {
        deployStage,
        ...getByfunnPulseSdkConfigInput(),
      },
      {
        actor: getActorPromise(),
        provider: {
          id: providerId,
          productTag,
          product: 'fastenposten',
          productType: 'ResponsiveWeb',
        },
      },
    );

    if (deployStage === 'dev') {
      tracker.update({ deployTag, deployStage });
    }

    return tracker;
  });

  return byfunnPulseTracker;
};
